export const styles = {
	dialogContent: {
		'&.MuiDialogContent-root': {
			paddingTop: 0
		}
	},
	dialogAction: {
		padding: '0 0 16px 16px'
	},
	dialog: {
		'& .MuiDialog-paper': {
			minHeight: 550,
			padding: '10px',
			position: 'relative'
		}
	},
	centered: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: 2,
		backgroundColor: '#fff'
	},
	closeIcon: {
		position: 'absolute',
		right: 8,
		top: 8,
		color: '#aaa'
	},
	paymentResult: {
		padding: '8px 24px',
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',

		'& > svg': {
			width: 100,
			height: 100
		}
	},
	title: {
		fontWeight: 600,
		textTransform: 'uppercase',
		fontSize: '1rem'
	},
	listRow: {
		display: 'flex',
		'& > div:last-child': {
			flexBasis: '60%',
			flexGrow: 0
		}
	},
	listWrapper: {
		padding: '16px'
	},
	paper: {
		position: 'relative',
		margin: `0 8px`,
		minHeight: 180,
		width: 'calc(100% - 100px)',
		marginLeft: 'auto'
	},
	fabProgress: {
		color: 'primary.main',
		zIndex: 1
	},
	centeredSubscription: {
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	btnUpdate: {
		color: '#212121',
		backgroundColor: '#8098b2'
	}
};
